import React, { useEffect, useState } from "react";
import styles from "./TopReservers.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy, faMedal } from "@fortawesome/free-solid-svg-icons";
import { useVarauskalenteritRaportointi } from "../Commoncontext/VarauskalenteritRaportointiContext";

const TopReservers = ({ selectedMonths }) => {
  const { raportointiData } = useVarauskalenteritRaportointi();
  const [topReservers, setTopReservers] = useState([]);

  useEffect(() => {
    if (!raportointiData || raportointiData.length === 0) return;
    const userAggregates = {};
    selectedMonths.forEach((monthKey) => {
      const monthData = raportointiData.find(
        (entry) => `${entry.vuosi}-${entry.kuukausi}` === monthKey
      );
      if (monthData && monthData.users) {
        monthData.users.forEach((user) => {
          if (!userAggregates[user.käyttäjäid]) {
            userAggregates[user.käyttäjäid] = {
              käyttäjäid: user.käyttäjäid,
              etunimi: user.etunimi,
              sukunimi: user.sukunimi,
              reservations: 0,
            };
          }
          userAggregates[user.käyttäjäid].reservations += user.reservations;
        });
      }
    });
    const sortedReservers = Object.values(userAggregates)
      .sort((a, b) => b.reservations - a.reservations)
      .slice(0, 3); // Otetaan vain 3 parasta
    setTopReservers(fillEmptySlots(sortedReservers));
  }, [raportointiData, selectedMonths]);

  const fillEmptySlots = (data) => {
    const emptySlot = { etunimi: "Ei", sukunimi: "varauksia", reservations: "-" };
    while (data.length < 3) {
      data.push(emptySlot);
    }
    return data.slice(0, 3);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FontAwesomeIcon icon={faMedal} className={styles.icon} />
        <span>Top varaajat</span>
      </div>
      <ul className={styles.list}>
        {topReservers.map((user, index) => (
          <li key={user.käyttäjäid} className={styles.listItem}>
            <FontAwesomeIcon
              icon={faTrophy}
              className={`${styles.trophy} ${
                index === 0
                  ? styles.gold
                  : index === 1
                  ? styles.silver
                  : styles.bronze
              }`}
            />
            <span className={styles.name}>{user.etunimi + " " + user.sukunimi || "Nimetön"}</span>
            <span className={styles.reservations}>
              {user.reservations} kpl
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TopReservers;
